import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { fetchLastPriceForMints } from 'utils/tokens'
import { SOL_MINT } from '../utils/constants'
import { milliseconds } from 'date-fns'

export type Token = {
  image: string
  mint: string
  name: string
  symbol: string
}

const fetchSolPrice = async () => {
  try {
    const data = await fetchLastPriceForMints([SOL_MINT])
    return data?.[0]?.price ?? 0
  } catch (e) {
    console.error('failed to fetch sol price', e)
    return 0
  }
}

export const useSolPrice = () => {
  const [solPrice, setSolPrice] = useState(0)
  const { data: price } = useQuery({
    queryKey: ['sol-price'],
    queryFn: fetchSolPrice,
    cacheTime: milliseconds({ minutes: 30 }),
    staleTime: milliseconds({ minutes: 30 }),
    retry: 3,
    refetchInterval: milliseconds({ seconds: 30 }),
    refetchOnWindowFocus: false,
  })

  useEffect(() => {
    if (price) {
      setSolPrice(price)
    }
  }, [price])

  return { solPrice }
}
